import { render, staticRenderFns } from "./s1-4.vue?vue&type=template&id=65a0c524&scoped=true&"
import script from "./s1-4.vue?vue&type=script&lang=js&"
export * from "./s1-4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a0c524",
  null
  
)

export default component.exports